module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.report.IsPlaceHolder) ? _c('div', {
    staticClass: "clearfix"
  }) : _c('div', {
    staticClass: "detailContent",
    attrs: {
      "title": 'This is a ' + (_vm.report.IsReport ? 'report' : 'dashboard')
    }
  }, [_c('div', {
    class: 'detailContentWap ' + _vm.color
  }, [_c('div', {
    staticClass: "detailContentBlock"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.report.Url
    }
  }, [_c('div', {
    staticClass: "detailContentWap"
  }, [_c('div', {
    staticClass: "detailContentTitle"
  }, [_vm._v("\n                        " + _vm._s(_vm.report.ReportName) + "\n                    ")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "detailContentText"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.report.Description)
    }
  }), _vm._v(" "), (_vm.report.ReportType == 'SelfService' && _vm.report.ReportOwner != 'admin.e1') ? [_c('br'), _vm._v(" To delete it, click the delete button. "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.deleteWorkbook(_vm.report.ReportId)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-delete"
  })])] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-74e96220!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Report.vue
// module id = 482
// module chunks = 2